
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/puppy-travel",
      function () {
        return require("private-next-pages/puppy-travel/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/puppy-travel"])
      });
    }
  